import { render } from "./MailinglistInfo.vue?vue&type=template&id=39271a52&scoped=true"
import script from "./MailinglistInfo.vue?vue&type=script&lang=js"
export * from "./MailinglistInfo.vue?vue&type=script&lang=js"

import "./MailinglistInfo.vue?vue&type=style&index=0&id=39271a52&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39271a52"]])

export default __exports__